var _excluded = ["title", "description", "footer", "trigger", "children", "cancelText", "confirmText", "onCancel", "onConfirm", "cancelButtonProps", "confirmButtonProps", "className", "mask", "hiddenCloseIcon", "maskClosable", "contentClassName", "footerClassName"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Button } from "../Button";
import { cn } from "../lib/utils";
import { Sheet, SheetClose, SheetContent, SheetFooter, SheetHeader, SheetTrigger } from "./sheet";
export var Drawer = function Drawer(_ref) {
  var title = _ref.title,
    description = _ref.description,
    footer = _ref.footer,
    trigger = _ref.trigger,
    children = _ref.children,
    cancelText = _ref.cancelText,
    confirmText = _ref.confirmText,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm,
    cancelButtonProps = _ref.cancelButtonProps,
    confirmButtonProps = _ref.confirmButtonProps,
    className = _ref.className,
    _ref$mask = _ref.mask,
    mask = _ref$mask === void 0 ? true : _ref$mask,
    hiddenCloseIcon = _ref.hiddenCloseIcon,
    _ref$maskClosable = _ref.maskClosable,
    maskClosable = _ref$maskClosable === void 0 ? true : _ref$maskClosable,
    contentClassName = _ref.contentClassName,
    footerClassName = _ref.footerClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Sheet, props, /*#__PURE__*/React.createElement(SheetTrigger, {
    asChild: true
  }, trigger), /*#__PURE__*/React.createElement(SheetContent, {
    position: "right",
    size: "default",
    className: cn('h-full flex flex-col p-0 w-[400px]', className),
    mask: mask,
    hiddenCloseIcon: hiddenCloseIcon,
    onInteractOutside: function onInteractOutside(e) {
      if (!maskClosable) {
        e.preventDefault();
      }
    }
  }, /*#__PURE__*/React.createElement(SheetHeader, {
    className: "p-6 pb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "font-medium text-gray-900 text-xl dark:text-foreground"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-500 text-sm dark:text-muted-foreground"
  }, description)))), /*#__PURE__*/React.createElement("div", {
    className: cn('flex-1 px-6 min-h-0 overflow-y-auto', contentClassName)
  }, children), footer === false ? null : footer || /*#__PURE__*/React.createElement(SheetFooter, {
    className: cn('border-t border-gray-200 dark:border-border flex justify-end gap-[12px] px-6 py-4', footerClassName)
  }, /*#__PURE__*/React.createElement(SheetClose, {
    asChild: true
  }, /*#__PURE__*/React.createElement(Button, _extends({
    variant: "outline"
  }, cancelButtonProps, {
    onClick: onCancel
  }), cancelText || 'Cancel')), /*#__PURE__*/React.createElement(Button, _extends({}, confirmButtonProps, {
    onClick: onConfirm
  }), confirmText || 'Confirm'))));
};